import AvailableShifts from '../pages/shiftBooking/AvailableShifts'
import MyPay from '../pages/shiftBooking/MyPay'
import MyShifts from '../pages/shiftBooking/MyShifts'
import OvertimeClaims from '../pages/admin/personnel/shifts/overtimeClaims/OvertimeClaims'
import ShiftApplications from '../pages/admin/ShiftApplications/Applications'
import ShiftSwapRequests from '../pages/admin/ShiftApplications/ShiftSwapRequests'

export default [
  {
    path: '/available-shifts',
    element: <AvailableShifts />,
    title: 'Available Shifts',
  },
  { path: '/my-shifts', element: <MyShifts />, title: 'My Shifts' },
  { path: '/my-pay', element: <MyPay />, title: 'My Pay' },
  {
    path: '/shift-applications',
    element: <ShiftApplications />,
    title: 'Shift Applications',
  },
  {
    path: '/shift-swap-requests',
    element: <ShiftSwapRequests />,
    title: 'Shift Swap Requests',
  },
  {
    path: '/overtime-claims',
    element: <OvertimeClaims />,
    title: 'Overtime Claims',
  },
  //   { path: '/global-roster', element: <GlobalRosterList /> },
]
